import {component, dateField, EntityData, field, identifier, LocalisableEntityData} from "@fedeltapointofsale/data-client";
import {ContactData} from "../../contact/contact.data";
import {PriceLevelReferenceData} from "../../pricing/price-level/price-level.data";
import {DiscountReferenceData} from "../../pricing/discount/discount.data";

export class MembershipTypeDataForMember extends EntityData<MembershipTypeDataForMember> {
    @field membershipTypeId: number;
    @field name: string;
}

export class AccountDataForMember extends EntityData<AccountDataForMember> {
    @identifier accountId: number;
}

export class MemberRenewalData extends EntityData<MemberRenewalData> {
    @dateField startDate: Date;
    @dateField expiryDate: Date;
}

// MemberData is not localisable, but the ContactData component is,
// so MemberData is marked localisable to allow the localisation context to be inherited when a new member is created.
export class MemberData extends LocalisableEntityData<MemberData> {
    @identifier memberId: string;
    @field integratedLoyaltyId: string;
    @field memberNo: string;
    @field memberCardNo: string;
    @component membershipType: MembershipTypeDataForMember;
    @component chargeAccount: AccountDataForMember;
    @dateField joiningDate: Date;
    @component contact: ContactData;
    @component memberRenewal: MemberRenewalData;
    @field discountId: number;
    @field priceLevelId: number;
    @field discontinued: boolean;

    @component pricingPriceLevel: PriceLevelReferenceData;
    @component pricingDiscount: DiscountReferenceData;

    // used in the validation
    memberNoAuto: boolean
}
